import { Injectable } from '@angular/core';
import { IFilter } from '@shared/interfaces/filter.interface';
import { IUser } from '@shared/interfaces/user.interface';
import { Filter } from '@shared/models/filter.model';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';
import { UsersService } from '@shared/services/users.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationUsersService extends PaginationService<IUser> {
  private static readonly DEFAULT_IS_DELETED_FILTER: IFilter = {
    label: 'COMMON.ACTIVE',
    key: 'isDeleted',
    value: 'false'
  };

  private static readonly DEFAULT_SEARCH_FILTER: IFilter = {
    key: 'search',
    value: null
  };

  private _filtersScope: any;

  constructor(_paginable: UsersService, _logger: LoggerService) {
    super(_paginable, _logger);

    this.setFilters([
      PaginationUsersService.DEFAULT_IS_DELETED_FILTER,
      PaginationUsersService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public getFilters(): IFilter[] {
    return this._filtersScope;
  }

  public reset() {
    super.reset();

    this.setFilters([
      PaginationUsersService.DEFAULT_IS_DELETED_FILTER,
      PaginationUsersService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public setFilters(filters: Partial<IFilter>[]): void {
    this._filtersScope = filters.map((f) => new Filter(f));
    super.setFilters(this._filtersScope);
  }
}
